import { TESTIMONIALS } from "./constants";

export const TestimonialsSection = () => (
  <section
    id="testimonials"
    className="testimonials"
    data-testid="testimonials-section"
  >
    <div className="section-head reveal">
      <div className="section-eyebrow">Voices from the community</div>
      <h2 className="section-title">
        Used by <span className="gold">members who love learning</span>.
      </h2>
    </div>
    <div className="testimonial-grid">
      {TESTIMONIALS.map((t, i) => (
        <figure
          className="testimonial-card reveal"
          key={t.name}
          style={{ transitionDelay: `${i * 80}ms` }}
          data-testid={`testimonial-${i}`}
        >
          <blockquote>&ldquo;{t.text}&rdquo;</blockquote>
          <figcaption>
            <div className="testimonial-name">{t.name}</div>
            <div className="testimonial-role">{t.role}</div>
          </figcaption>
        </figure>
      ))}
    </div>
  </section>
);
